module.exports = __webpack_public_path__ + "static/media/Quest West.cbb7193a.png";